import { Button } from '@sparemin/blockhead';
import React from 'react';
import { useSelector } from 'react-redux';
import { createCreationAssetStatusSelector } from 'redux/modules/wizard-export/selectors';
import { RequestStatus } from 'types';
import { block } from './utils';

export interface EditTemplateModalHeaderProps {
  onSave?: () => void;
  onCancel?: () => void;
}

const EditTemplateModalHeader: React.FC<EditTemplateModalHeaderProps> = ({
  onSave,
  onCancel,
}) => {
  const createCreationAssetStatus = useSelector(
    createCreationAssetStatusSelector,
  );

  return (
    <div className={block('header')}>
      <Button variant="ghost" onPress={onCancel}>
        cancel
      </Button>

      <Button
        variant="solid"
        disabled={createCreationAssetStatus === RequestStatus.REQUEST}
        onPress={onSave}
      >
        save changes
      </Button>

      <span className={block('divider')} />
    </div>
  );
};

export default EditTemplateModalHeader;
